import type { TimeEntry } from "~generated";
import type { EmbeddedTimeEntry } from "./EmbeddedTimeEntry.ts";

export function timeEntriesGroupedByDateAndResourceKey(
  timeEntry: TimeEntry,
): string {
  return `${timeEntry.start_time?.substring(0, 10)}${timeEntry.resource.id}`;
}

export function timeEntriesGroupedByDateAndTimeTrackingKey(
  timeEntry: EmbeddedTimeEntry,
): string {
  return `${timeEntry.start_time?.substring(0, 10)}${timeEntry.time_tracking_id}`;
}
